import React from "react";
import { Spacer } from "~/components/Spacer";
import { Text } from "~/components/Text";
import { View } from "~/components/View";
import { useResponsive } from "../live-chat/useResponsive";

export function SectionBokBokDatingAppText() {
  const r = useResponsive();

  return (
    <View
      paddingHorizontalLarge
      colorBackgroundLightDark
      style={{
        flex: r(-1, -1, 1),
        justifyContent: r("flex-start", "flex-start", "center"),
      }}
    >
      <View style={{ maxWidth: 1320, marginHorizontal: "auto" }}>
        <Spacer medium />
        <Text
          sizeLarge
          alignCenter={r(true, true, false)}
          alignLeft={r(false, false, true)}
        >
          {intl.formatMessage({
            defaultMessage:
              "BokBok redefines the dating experience with new innovative features!",
            id: "grXCEj",
            description: "Section text",
          })}
        </Text>

        <Spacer extraLarge />

        <Text weightExtraBold>
          {intl.formatMessage({
            defaultMessage: "Video Profiles",
            id: "dQXt2A",
            description: "Section title",
          })}
        </Text>

        <Spacer medium />

        <Text>
          {intl.formatMessage({
            defaultMessage:
              "As a Tinder alternative, BokBok’s video profiles change how you connect. Quickly swipe through videos to find a casual date or explore potential matches for serious relationships. BokBok is especially suited for college students, making it easy to create genuine connections through familiar video interactions.",
            id: "VyHxAC",
            description: "Section text",
          })}
        </Text>

        <Spacer extraLarge />
        <Spacer extraLarge />

        <Text weightExtraBold>
          {intl.formatMessage({
            defaultMessage: "Speed Dating Events",
            id: "NLppcT",
            description: "Section title",
          })}
        </Text>
        <Spacer medium />

        <Text>
          {intl.formatMessage({
            defaultMessage:
              "With BokBok, you can join quick dating events from anywhere. Our app automatically connects you for live video calls with people nearby or around the world. Use BokBok whether you’re looking for local dates or interested in long-distance relationships. Engage in real-time, face-to-face dating without leaving your home.",
            id: "aZ9AHM",
            description: "Section text",
          })}
        </Text>
      </View>
    </View>
  );
}
